import { render } from "./App.vue?vue&type=template&id=f5d9874e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/styles/styles.css?vue&type=style&index=0&lang=css&external"
import "@/styles/dissentiaStyles.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__